// para modificar una modalidad de torneo
export const SET_CARTA_TEMPLATE = 'SET_CARTA_TEMPLATE'
export const SET_PLATOS_CARTA = 'SET_PLATOS_CARTA'
export const SET_TEMA_TEMP = 'SET_TEMA_TEMP'
